function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { Component } from "react";
import { findDOMNode, render, unmountComponentAtNode } from "react-dom";
import { injectIntl } from "react-intl";
import propTypes from "prop-types";
import ExtensionAPI from "../utils/ExtensionAPI";
import omit from "lodash/omit";
import isString from "lodash/isString";
import isEqual from "lodash/isEqual";
import every from "lodash/every";
import raf from "raf";
import classNames from "classnames";
import { getPrintNotesByChart } from "../utils/SocialNotesUtils";
var checkLoaded = function(frame, ready) {
    var doc = frame.contentDocument || frame.contentWindow && frame.contentWindow.document;
    if (doc && doc.URL.indexOf("about:") !== 0) {
        if (doc.readyState === "complete") {
            ready(frame);
        } else {
            doc.addEventListener("DOMContentLoaded", function() {
                return ready(frame);
            });
            doc.addEventListener("readystatechange", function(ev) {
                if (doc.readyState === "complete" || doc.readyState === "interactive") {
                    ready(frame);
                }
            });
        }
    } else {
        setTimeout(function() {
            return checkLoaded(frame, ready);
        }, 1);
    }
};
var getFrameDoc = function(node) {
    return node && (node.contentDocument || node.contentWindow.document);
};
var isIE = window.navigator.userAgent.indexOf("MSIE") > -1 || !!navigator.userAgent.match(/Trident.*rv:11\./);
var Preview = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Preview, Component);
    var _super = _createSuper(Preview);
    function Preview(props) {
        _classCallCheck(this, Preview);
        var _this;
        _this = _super.call(this, props);
        _this._prepareFrame = _this._prepareFrame.bind(_assertThisInitialized(_this));
        _this.renderContent = _this.renderContent.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = Preview.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._prepareFrame();
        raf(this.renderContent);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var fdoc = getFrameDoc(findDOMNode(this));
        unmountComponentAtNode(fdoc.getElementById("p"));
    };
    /* componentWillReceiveProps (nextProps) {
    if (nextProps.styleSheets !== this.props.styleSheets || nextProps.title !== this.props.title) {
      const fdoc = getFrameDoc(this);
      const cont = fdoc.getElementById('p');
      unmountComponentAtNode(cont);
      cont.parentNode.removeChild(cont);
    }
  } */ _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevProps.styleSheets !== this.props.styleSheets || this.props.title !== prevProps.title) {
            this._prepareFrame();
        }
        if (prevProps.update !== this.props.update || prevProps.styleSheets !== this.props.styleSheets || this.props.title !== prevProps.title) {
            raf(this.renderContent);
        }
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.update !== this.props.update || nextProps.styleSheets !== this.props.styleSheets || this.props.title !== nextProps.title || this.props.style !== nextProps.style;
    };
    _proto._prepareFrame = function _prepareFrame() {
        var fdoc = getFrameDoc(findDOMNode(this));
        var cont = fdoc.getElementById("p");
        var devStyles = [
            "css/print.css",
            "css/client.css",
            "css/accessibility.css",
            "css/last.css"
        ];
        var styleSheets = [];
        if (this.props.styleSheets) {
            if (isString(this.props.styleSheets)) {
                styleSheets.push(this.props.styleSheets);
            } else {
                styleSheets = styleSheets.concat(this.props.styleSheets);
            }
        }
        if (!cont) {
            fdoc.open();
            fdoc.close();
            fdoc.documentElement.innerHTML = "<head>".concat(devStyles.map(function(ss) {
                return '<link href="' + ss + '" rel="stylesheet" /> \n';
            }).join(""), "<title>").concat(this.props.title, '</title></head><body class="preview"><div id="p"><div></body>');
        } else {
            fdoc.head.innerHTML = "".concat(_toConsumableArray(devStyles).concat(_toConsumableArray(styleSheets)).map(function(ss) {
                return '<link href="' + ss + '" rel="stylesheet" /> \n';
            }).join(""), "<title>").concat(this.props.title, "</title>");
        }
    };
    _proto.renderContent = function renderContent() {
        var fdoc = getFrameDoc(findDOMNode(this));
        var elm = fdoc.getElementById("p");
        var children = this.props.children;
        if (fdoc.readyState === "complete" && !!elm && children) {
            render(children, elm);
        } else {
            raf(this.renderContent);
        }
    };
    _proto.render = function render() {
        var other = omit(this.props, [
            "title",
            "styleSheets",
            "children",
            "update"
        ]);
        return /*#__PURE__*/ React.createElement("iframe", _extends({}, other));
    };
    return Preview;
}(Component);
Preview.propTypes = {
    styleSheets: propTypes.oneOfType([
        propTypes.string,
        propTypes.arrayOf(propTypes.string)
    ]),
    title: propTypes.string
};
Preview.displayName = "Preview";
var PRINT_LAYOUT = {
    SINGLE: "single",
    WITH_NOTES: "withNotes",
    TWO_ON_SITE: "twoOnSite"
};
var PrintView = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(PrintView, Component);
    var _super = _createSuper(PrintView);
    function PrintView(props) {
        _classCallCheck(this, PrintView);
        var _this;
        _this = _super.call(this, props);
        _this.renderChart = function(chart) {
            var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            var _this_props = _this.props, cbook = _this_props.cbook, printNotes = _this_props.printNotes;
            var style = {};
            var isQuestion = chart.answers && chart.answers.length;
            var notes = getPrintNotesByChart(chart.id, printNotes);
            if (chart.background_image) {
                style.backgroundImage = 'url("'.concat(encodeURI(chart.background_image), '")');
            }
            return /*#__PURE__*/ React.createElement("div", {
                className: "chart-wrapper",
                key: chart.id,
                title: "".concat(cbook === null || cbook === void 0 ? void 0 : cbook.name, " - ").concat(chart.name)
            }, /*#__PURE__*/ React.createElement("div", {
                className: "chart clientcss"
            }, !isQuestion && !chart.url ? /*#__PURE__*/ React.createElement("div", {
                className: "mce-content-body clientcss__body",
                style: style,
                dangerouslySetInnerHTML: {
                    __html: chart.cont
                }
            }) : !chart.url && /*#__PURE__*/ React.createElement("div", {
                className: "mce-content-body clientcss__body",
                style: style
            }, /*#__PURE__*/ React.createElement("div", {
                className: "question"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "question__cont",
                dangerouslySetInnerHTML: {
                    __html: chart.cont
                }
            }), /*#__PURE__*/ React.createElement("ul", null, chart.answers.map(function(a, i) {
                return /*#__PURE__*/ React.createElement("li", {
                    key: "a".concat(i),
                    className: a.num ? "correct" : ""
                }, a.name);
            })))), chart.url && /*#__PURE__*/ React.createElement("iframe", {
                ref: function(iframe) {
                    if (iframe) {
                        iframe.contentWindow.chartId = chart.id;
                        iframe.contentWindow.printLayout = true;
                        var injStyle = iframe.contentDocument.createElement("style");
                        injStyle.appendChild(iframe.contentDocument.createTextNode("@media only print{ * { -webkit-print-color-adjust: exact !important;color-adjust: exact !important; }}"));
                        var to;
                        iframe.contentWindow.addEventListener("printable", function() {
                            if (to) {
                                clearTimeout(to);
                                to = null;
                            }
                            _this._setLoaded(chart.id);
                        }, false);
                        iframe.onload = function(evnt) {
                            iframe.contentDocument.head.insertBefore(injStyle, null);
                            to = setTimeout(function() {
                                _this._setLoaded(chart.id);
                            }, 1950 + n * 25);
                            _this.sts.push(to);
                        };
                        iframe.contentWindow.onerror = function(message, source, linen, coln, error) {
                            to = setTimeout(function() {
                                _this._setLoaded(chart.id);
                            }, 1950 + n * 25);
                            _this.sts.push(to);
                        };
                        var session = ExtensionAPI.createSession({
                            scope: {
                                chartId: chart.id,
                                frame: iframe
                            }
                        });
                        checkLoaded(iframe, function(frame) {
                            if (!frame.contentWindow.ExtensionAPI) {
                                frame.contentWindow.ExtensionAPI = session;
                            }
                        });
                        if (iframe.contentWindow) {
                            iframe.contentWindow.ExtensionAPI = session;
                        }
                    }
                },
                className: "print-extension-preview",
                src: chart.url
            })), !!notes.length && _this.state.printLayout === PRINT_LAYOUT.WITH_NOTES && /*#__PURE__*/ React.createElement("div", {
                className: classNames("print-notes", {
                    "print-notes--m3": notes.length > 3
                })
            }, notes.map(_this.renderNote)));
        };
        _this._setLoaded = function(id) {
            if (_this.state.loading.indexOf(id) === -1) {
                var loading = _this.state.loading.slice();
                loading.push(id);
                _this.setState({
                    loading: loading
                });
            }
        };
        _this._onPrint = function(evnt) {
            evnt.preventDefault();
            var win = findDOMNode(_this.printPreview).contentWindow;
            var fdoc = getFrameDoc(findDOMNode(_this.printPreview));
            fdoc.body.className = fdoc.body.className.replace("preview", "");
            win.focus();
            if (!fdoc.execCommand("print", false, null)) {
                win.print();
            }
            fdoc.body.className = "".concat(fdoc.body.className, " preview");
        };
        _this._onNotesChange = function() {
            var _this_props = _this.props, currentSlide = _this_props.currentSlide, printNotes = _this_props.printNotes;
            _this.setState({
                notes: getPrintNotesByChart(currentSlide, printNotes)
            });
        };
        _this._onToggleLayout = function(layout) {
            _this.setState({
                printLayout: layout
            });
        };
        _this._onToggleCharts = function() {
        /* this.setState({
      currentChartOnly: !this.state.currentChartOnly,
      favouritesOnly: false
    }) */ };
        _this._onToggleFavourites = function() {
        /* this.setState({
      currentChartOnly: false,
      favouritesOnly: !this.state.favouritesOnly
    }) */ };
        _this.state = {
            notes: getPrintNotesByChart(props.currentSlide, props.printNotes),
            withNotes: false,
            currentChartOnly: true,
            favouritesOnly: false,
            printLayout: isIE ? PRINT_LAYOUT.TWO_ON_SITE : PRINT_LAYOUT.SINGLE,
            loading: [],
            charts: props.searchableSlides.filter(function(n) {
                return n.id === props.currentSlide;
            })
        };
        _this.sts = [];
        return _this;
    }
    var _proto = PrintView.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.fetchPrintNotes();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // clearup timeouts
        this.sts.forEach(function(to) {
            if (to) {
                clearTimeout(to);
            }
        });
    };
    _proto.UNSAFE_componentWillUpdate = function UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (!isEqual(nextState.charts, this.state.charts) || !isEqual(nextState.printLayout, this.state.printLayout) || !isEqual(nextState.currentChartOnly, this.state.currentChartOnly) || !isEqual(nextState.favouritesOnly, this.state.favouritesOnly) || !isEqual(nextState.withNotes, this.state.withNotes)) {
            this.sts.forEach(function(to) {
                if (to) {
                    clearTimeout(to);
                }
            });
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var printLayout = this.state.printLayout;
        var _this_props = this.props, currentSlide = _this_props.currentSlide, printNotes = _this_props.printNotes;
        if (this.printPreview) {
            var fdoc = getFrameDoc(findDOMNode(this.printPreview));
            var resetClasses = function() {
                fdoc.body.className = fdoc.body.className.replace(/(with-notes|two-on-site)/, "");
            };
            resetClasses();
            switch(printLayout){
                case PRINT_LAYOUT.WITH_NOTES:
                    fdoc.body.className = "".concat(fdoc.body.className, " with-notes");
                    break;
                case PRINT_LAYOUT.TWO_ON_SITE:
                    fdoc.body.className = "".concat(fdoc.body.className, " two-on-site");
                    break;
                default:
            }
        }
        if (currentSlide !== prevProps.currentSlide) {
            this.setState({
                notes: getPrintNotesByChart(currentSlide, printNotes)
            });
        }
        if (!isEqual(prevProps.printNotes, printNotes)) {
            this._onNotesChange();
        }
    };
    _proto.renderNote = function renderNote(note, i) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "note",
            key: i
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "note__title"
        }, note.title), /*#__PURE__*/ React.createElement("div", {
            className: "note__body",
            dangerouslySetInnerHTML: {
                __html: note.description
            }
        }));
    };
    _proto.renderPreview = function renderPreview() {
        return /*#__PURE__*/ React.createElement("div", null, this.state.charts.map(this.renderChart));
    };
    _proto.render = function render() {
        var _this = this;
        var _this_state = this.state, notes = _this_state.notes, printLayout = _this_state.printLayout, charts = _this_state.charts, loading = _this_state.loading;
        var _this_props = this.props, close = _this_props.close, intl = _this_props.intl;
        var loadableCharts = charts.filter(function(c) {
            return !!c.url;
        }).map(function(c) {
            return c.id;
        });
        var loaded = every(loadableCharts, function(id) {
            return loading.indexOf(id) > -1;
        });
        var progress = Math.min(Math.max(loading.length / loadableCharts.length * 100, 0), 100);
        var previewCSS = classNames("print-app__preview-wrapper", {
            "print-app__preview-wrapper--heigh": printLayout !== PRINT_LAYOUT.SINGLE
        });
        var layoutOptions = [
            {
                value: PRINT_LAYOUT.TWO_ON_SITE,
                txt: intl.formatMessage({
                    id: "print.layout.two_on_site",
                    defaultMessage: "Two Slides on one site"
                })
            }
        ];
        if (!isIE) {
            layoutOptions.splice(0, 0, {
                value: PRINT_LAYOUT.SINGLE,
                txt: intl.formatMessage({
                    id: "print.layout.single",
                    defaultMessage: "One Slide per page"
                })
            });
        }
        if (notes.length) {
            layoutOptions.push({
                value: PRINT_LAYOUT.WITH_NOTES,
                txt: intl.formatMessage({
                    id: "print.layout.with_notes",
                    defaultMessage: "With Notes"
                })
            });
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: "print-app"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "print-app__left-col"
        }, /*#__PURE__*/ React.createElement("h2", {
            className: "print-app__header"
        }, intl.formatMessage({
            id: "print.print",
            defaultMessage: "Print"
        })), /*#__PURE__*/ React.createElement("ul", {
            className: "print-app__options"
        }, /*#__PURE__*/ React.createElement("li", {
            className: "print-app__option"
        }, /*#__PURE__*/ React.createElement("label", {
            htmlFor: "layout"
        }, intl.formatMessage({
            id: "print.layout.label",
            defaultMessage: "Layout"
        })), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("select", {
            className: "layout-select",
            value: printLayout,
            onSelect: this._onToggleLayout
        }, layoutOptions.map(function(l) {
            return /*#__PURE__*/ React.createElement("option", {
                key: l.value,
                value: l.value
            }, l.txt);
        })))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("button", {
            className: "btn btn--secondary",
            name: "printViewCloseBtn",
            onClick: close
        }, intl.formatMessage({
            id: "print.cancel",
            defaultMessage: "cancel"
        })), /*#__PURE__*/ React.createElement("button", {
            disabled: !loaded,
            name: "printBtn",
            className: "btn btn--primary icon-print icon-print--white",
            onClick: this._onPrint
        }, intl.formatMessage({
            id: "print.print",
            defaultMessage: "print"
        })))), /*#__PURE__*/ React.createElement("div", {
            className: previewCSS
        }, !loaded && /*#__PURE__*/ React.createElement("span", {
            className: "print-app__loading-msg",
            dangerouslySetInnerHTML: {
                __html: intl.formatMessage({
                    id: "print.generating",
                    defaultMessage: "generating"
                })
            }
        }), !loaded && /*#__PURE__*/ React.createElement("div", {
            className: "print-app__loading-bar"
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                width: "".concat(progress, "%")
            },
            className: "print-app__loading-bar-inner"
        })), /*#__PURE__*/ React.createElement(Preview, {
            ref: function(el) {
                _this.printPreview = el;
            },
            update: printLayout + charts.map(function(c) {
                return c.id;
            }).join(","),
            style: {
                opacity: loaded ? 1 : 0
            },
            title: document.getElementsByTagName("title")[0].cloneNode(true).innerHTML,
            styleSheets: printLayout !== PRINT_LAYOUT.SINGLE ? "css/printV.css" : null,
            className: "print-app__preview"
        }, this.renderPreview())));
    };
    return PrintView;
}(Component);
export default injectIntl(PrintView);
